export enum CoreTheme {
  default = 'my-theme',
  light = 'my-light-theme',
  dark = 'my-dark-theme',
}
